// src/pages/produtos/ProdutoPage.js
import React from 'react';
import PDV2 from './PDV2';
import { CaixaProvider } from '../../contexts/caixas/CaixaContext';
import { NotaPagProvider } from '../../contexts/vendas/NotaPagContext';
import { PDVProvider } from '../../contexts/vendas/PDVContext';
import { CaixaMovProvider } from '../../contexts/caixas/CaixaMovContext';
import { CaixaResumoProvider } from '../../contexts/caixas/CaixaResumoContext';

const PDVPage = () => {
    return (             
        <CaixaResumoProvider>
            <CaixaMovProvider>
                <CaixaProvider>                                          
                    <PDVProvider>
                        <NotaPagProvider>                        
                            <PDV2 />
                        </NotaPagProvider> 
                    </PDVProvider>                                                    
                </CaixaProvider>
            </CaixaMovProvider>
        </CaixaResumoProvider>         
    );
};

export default PDVPage;